module.exports = __webpack_public_path__ + "img/FIRENZE.95164d4e.png";